import React from 'react';
import { apps } from '../data/apps';

const billedApps = apps.filter((app) => app.webBilling);

// 网页订阅的说明：卖的是什么、价格在哪看、谁收款、怎么退款。Paddle 审核网站时看这一块
const Billing: React.FC = () => {
  return (
    <section id="billing" className="billing">
      <div className="container">
        <h2 className="section-title">Pricing &amp; Billing</h2>
        <p className="section-subtitle">What we sell and how payments work</p>

        <div className="billing-grid">
          <div className="billing-card">
            <h3>What we sell</h3>
            <p>
              Our products are software: mobile apps and browser extensions. All apps can be downloaded
              for free. Some offer an optional Premium subscription that unlocks extra features inside the
              app, delivered online right after purchase.
            </p>
          </div>
          <div className="billing-card">
            <h3>Subscriptions</h3>
            <p>
              Premium is available as a monthly or yearly subscription. It renews automatically until
              you cancel. You can cancel at any time; Premium then stays active until the end of the
              period you already paid for.
            </p>
          </div>
          <div className="billing-card">
            <h3>Payments</h3>
            <p>
              Purchases on our websites are processed by our online reseller Paddle.com, our Merchant
              of Record. Paddle handles payment, invoices, sales tax, and
              refunds. Purchases inside the iOS or Android app are billed by Apple or Google.
            </p>
          </div>
        </div>

        <div className="billing-table-wrapper">
          <table className="billing-table">
            <thead>
              <tr>
                <th>App</th>
                <th>Premium price</th>
                <th>Refunds</th>
                <th>Legal</th>
              </tr>
            </thead>
            <tbody>
              {billedApps.map((app) => (
                <tr key={app.id}>
                  <td data-label="App">{app.title}</td>
                  <td data-label="Premium price">
                    {app.webBilling!.monthlyPrice} / month or {app.webBilling!.yearlyPrice} / year
                    <br />
                    <a href={app.webBilling!.pricingUrl} target="_blank" rel="noopener noreferrer">Plans and features</a>
                  </td>
                  <td data-label="Refunds">
                    <a href={app.webBilling!.refundUrl} target="_blank" rel="noopener noreferrer">{app.webBilling!.refundSummary}</a>
                  </td>
                  <td data-label="Legal">
                    <a href={app.webBilling!.termsUrl} target="_blank" rel="noopener noreferrer">Terms</a>
                    {' · '}
                    <a href={app.webBilling!.privacyUrl} target="_blank" rel="noopener noreferrer">Privacy</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="billing-note">
          Prices are shown in the app's default currency. At checkout, Paddle shows the price in your local
          currency, including or plus the sales tax that applies in your country.
        </p>

        <p className="billing-note">
          Our <a href="/terms">Terms of Sale</a>, <a href="/refund">Refund Policy</a>, and{' '}
          <a href="/privacy">Privacy Policy</a> apply to all purchases on our websites, together with the terms of
          each app linked above.
        </p>

        <p className="billing-note">
          Questions about a payment? Email <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a>.
          See our <a href="/imprint">Imprint</a> for our company details.
        </p>
      </div>
    </section>
  );
};

export default Billing;
